import type { TOC } from '@ember/component/template-only';
import { VStack } from 'tio-ui/components/layout';
import ManagePage from 'tio-employee/components/tas/applications/manage/manage-page';
import type { TasManageRouteModel } from 'tio-employee/utils/tas/manage-route';

interface ManageTemplateSignature {
  Args: { model: TasManageRouteModel };
}

const ManageTemplate: TOC<ManageTemplateSignature> = <template>
  <VStack>
    <ManagePage @application={{@model.application}} />
  </VStack>
</template>;

export default ManageTemplate;
